import {fetch} from '@/utils/fetch';

/**
 *
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getAreaList() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/areas`,
    method: 'get',
  });
}

export function getShipping() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/shipping`,
    method: 'get'
  })
}

export function findArea(id) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/areas/${ id }`,
    method: 'get',
  });
}

export function saveArea(area) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/areas`,
    method: 'post',
    data: area,
  });
}

export function updateArea(area) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/areas`,
    method: 'patch',
    data: area,
  });
}

export function delArea(id) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/areas/${ id }`,
    method: 'delete',
  });
}
